export default function PHP_ftp_connect() {
  return (
    <div>
      <h1>PHP_ftp_connect</h1>
    </div>
  );
}
